import { render, staticRenderFns } from "./CustomerSelectionSimplified.vue?vue&type=template&id=afa5c554&scoped=true"
import script from "./CustomerSelectionSimplified.vue?vue&type=script&lang=js"
export * from "./CustomerSelectionSimplified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa5c554",
  null
  
)

export default component.exports